export default __webpack_public_path__ + "static/media/workbook.3c24e810.svg";